import Breadcrumb from 'Components/UI/Breadcrumb';
import { Alert, Container } from "reactstrap";
import BookingForm from './Booking Form/Booking';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getBookingById } from 'helpers/API Calls/Operations/booking';
import { useDispatch } from 'react-redux';
import { setEditMode, setInitialCartState, setTaxesAndDeposits } from 'slices/booking/cartSlice';
import { BookingData } from 'types/booking';
import { setInitialBookingData } from 'slices/booking/bookingSlice';
import Spinner from 'Components/UI/Spinner';
import { getPublicAdminSettings } from 'helpers/API Calls/System & Settings/Admin Settings';
import { SettingItem } from 'types/types';

function EditBooking() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBooking = async () => {
      setLoading(true);
      let cleaningDeposit; 
      const response = await getBookingById(Number(id));
      const charges = await getPublicAdminSettings('key=REFUNDABLE_CLEANING_DEPOSIT');
      if(charges?.success) {
        cleaningDeposit = charges.data.find((item: SettingItem) => item.key === 'REFUNDABLE_CLEANING_DEPOSIT')?.value;
      }
      
      // console.log(response);
      if(response.success){
        dispatch(setEditMode(true));
        const data : BookingData = response.data;
        dispatch(setInitialBookingData({
          customer: data.customer, 
          delivery: data.delivery,
          accessibility_options: data.accessibility_options,
          booking_notes: data.booking_notes,
          booking_status: (data.booking_status.id).toString(),
          operator_notes: data.operator_notes,
          rental_agreement_signature: data.rental_agreement_signature,
          selectedPostcode : data.delivery.postcode_id ? {
            postcode: data.delivery.postcode_id,
            charges: data.payments?.[0]?.postcode_charges || 0,
          } : null, 
          referral_source: data.referral_source || '',
        }))
        dispatch(setInitialCartState({
          items: [
            ...data.products.map(product => ({
              id: product.product_id,
              name: product.product_name,
              amount: product.quantity,
              price: product.item_price,
              // requires_cleaning_deposit: false, 
            })),
            ...data.packages?.map(pkg => ({
              id: pkg.package_id.toString(),
              name: pkg.package_name,
              amount: pkg.quantity,
              price: pkg.item_price,
              type: 'package',
              requires_cleaning_deposit: pkg.products && pkg.products.some(product => product?.requires_cleaning_deposit),
              products: pkg.products.map(p => p.id.toString())
            })) || []
          ],
          bookingDate: data.booking_date,
          paymentMethod: data.payments?.[0]?.payment_method, 
          total: data.payments?.[0]?.total_amount, 
          payment: (data?.payments?.[0]?.payment_status_id)?.toString(),
          discountAmount: data.payments?.[0]?.discount_amount || 0,
          discountCode: data.payments?.[0]?.discount?.code || null,
          depositAmount: data.payments?.[0]?.deposit || 0,
          depositCollected: data.payments?.[0]?.deposit_collected || false,
          isPackageItem: data.packages?.length > 0 || false,
          AddedPackage: data.packages?.[0] ? {
            id: data.packages[0].package_id,
            name: data.packages[0].package_name,
            price: data.packages[0].item_price,
            products: data.packages[0].products
          } : null,
          paid_amount: data.payments?.[0]?.paid_amount || 0,
        }))
        // Dispatch VAT and cleaning deposit
        dispatch(setTaxesAndDeposits({
          vat: Number(data.payments[0].vat_percent) || 0,
          cleaningDeposit: Number(data.payments[0].refundable_cleaning_deposit) || 0,
          updatedCleaningDeposit: Number(cleaningDeposit) || 0,
          deposit: Number(data.payments[0].deposit) || 0,
          isDepositEnabled: data.payments[0].deposit_collected || false,
        }));
      }else {
        setError(response.message || 'Failed to load booking data');
      }
      setLoading(false);
    }
    fetchBooking();
  }, [id, dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Bookings", link: "/bookings" }, {label: 'Edit'}]} />
          {loading ? (
          <div className="position-relative vh-100"><Spinner/></div>
        ) : error ? (
          <Alert color="danger">{error}</Alert>
        ) : (
          <BookingForm/>
        )}
      </Container>
    </div>
  )
}

export default EditBooking
